import { t, Trans } from '@lingui/macro';
import { NoddiBasicCard } from 'noddi-ui-web';
import { InstructionRow } from '../InstructionsRow';

export const BookingProposalNextSteps = () => (
  <NoddiBasicCard className='flex flex-col gap-3'>
    <p className='mb-2 text-xl'>
      <Trans>What happens next?</Trans>
    </p>
    <InstructionRow
      icon='Check'
      title={t`Confirmation`}
      description={t`You'll receive an SMS confirmation with your booking details within the next few minutes. If you need to change the time of your booking, you can do so through your account.`}
    />
    <InstructionRow
      icon='ChatRounded'
      title={t`Communication`}
      description={t`The day before your appointment, you'll receive an SMS with a more precise estimated time window. You’ll also get a notification when you are next on the list.`}
    />
    <InstructionRow
      icon='Calendar'
      title={t`We are preparing your appointment`}
      description={t`Our team is preparing your tires and assigning your appointment to a skilled technician. You don’t need to do anything — just make sure you’re available around the scheduled time.`}
    />
  </NoddiBasicCard>
);
